import { getBaseQuery, getBaseUrl, REQUEST_TIMEOUT_MS } from '../api.util.ts'
import { createApi } from '@reduxjs/toolkit/query/react'
import {
  TickerPriceRequest,
  TickerPriceResponse,
  TickerSearchRequest,
  TickerSearchResponse,
  TickerShortableRequest,
  TickerShortableResponse,
} from './ticker-api.def.ts'

const interfaceName = 'ticker'

export const tickerApi = createApi({
  reducerPath: 'tickerApi',
  baseQuery: getBaseQuery(getBaseUrl(interfaceName), REQUEST_TIMEOUT_MS),
  tagTypes: ['ticker'],
  endpoints: (build) => ({
    searchTicker: build.query<TickerSearchResponse, TickerSearchRequest>({
      query: (params) => ({
        url: '/search',
        method: 'GET',
        params: params,
      }),
      providesTags: ['ticker'],
    }),
    getTickerPrice: build.query<TickerPriceResponse, TickerPriceRequest>({
      query: (payload) => ({
        url: '/price',
        method: 'POST',
        body: payload,
      }),
      providesTags: ['ticker'],
    }),
    getTickerShortable: build.query<
      TickerShortableResponse,
      TickerShortableRequest
    >({
      query: (payload) => ({
        url: '/shortable',
        method: 'POST',
        body: payload,
      }),
    }),
  }),
})

export const {
  useLazySearchTickerQuery,
  useLazyGetTickerPriceQuery,
  useGetTickerShortableQuery,
} = tickerApi
